import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Grid } from '@mui/material';
import ExtensivButton from '../ExtensivButton';
import MfaProviderLink from './MfaProviderLink';
import MfaTitleInstruction from './MfaTitleInstruction';
export default ({ isAlreadyConfigured = false, refreshSession, onDone, userEmail, getTotpSecretCode, verifyCode, isInitialSetup = false }) => {
    const [isMfaSetupSuccess, setIsMfaSetupSuccess] = useState(isAlreadyConfigured);
    const [isAllowContinue, setIsAllowContinue] = useState(false);
    const onSetupComplete = () => {
        setIsMfaSetupSuccess(true);
        refreshSession(() => setIsAllowContinue(true));
    };
    if (isMfaSetupSuccess) {
        return (_jsxs(Grid, Object.assign({ container: true, style: { textAlign: 'center' }, rowSpacing: 7 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(MfaTitleInstruction, { icon: 'success', title: 'Two-factor authentication is set up', instruction: 'Thank you for making your account more secure' }) })), _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(ExtensivButton, Object.assign({ onClick: onDone, disabled: !isAllowContinue }, { children: "Done" })) }))] })));
    }
    return (_jsx(MfaProviderLink, { onSetupComplete: onSetupComplete, userEmail: userEmail, getTotpSecretCode: getTotpSecretCode, verifyCode: verifyCode, isInitialSetup: isInitialSetup }));
};
//# sourceMappingURL=index.js.map